import Model from '@/Models/Model'

export default class Document extends Model {
  /**
   * Resource
   *
   * @returns {string}
   */
  resource() {
    return 'documents'
  }
}
